import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom'
import * as actionCreators from '../../../_store/actions/index';
import { getTranslate } from 'react-localize-redux';

import { Icon } from 'components'
import styles from './MainNav.scss';

class MainNav extends Component {
  componentDidMount() {
    if(this.props.auth.isAuthenticated) {
      this.props.onHelpersNotificationsMachinesFetch();
    }
  }

  render() {
    var showBatch = false;
    this.props.helpersNotifications.machines.list.forEach((machine,index) => {
      if (machine.incomplete) {
        showBatch = true;
      }
    })
    var content = "";
    if(this.props.auth.isAuthenticated) {
      content = (<nav className={styles.mainNav}>
        <ul>
          <li className={styles.isHiddenMobile}><NavLink to="/jobs" activeClassName={styles.isActive}>{this.props.translate('menu.jobs')}</NavLink></li>
            <li className={showBatch ? (styles.batch + ' ' + styles.isHiddenMobile) : styles.isHiddenMobile}><NavLink to="/machines" activeClassName={styles.isActive}>{this.props.translate('menu.machines')}</NavLink></li>
            <li className={styles.isHighlighted + ' ' + styles.isHiddenMobile}><NavLink to="/jobs/new">{this.props.translate('menu.new_job')}</NavLink></li>
          </ul>
      </nav>)
    }
    
    return content
  }
}


const mapStateToProps = state => {
    return {
        defaults: state.defaults,
        auth: state.auth,
        helpersNotifications: state.helpersNotifications,
        translate: getTranslate(state.locale) 
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onHelpersNotificationsMachinesFetch: () => dispatch(actionCreators.helpersNotificationsMachinesFetch()),
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(MainNav);



// WEBPACK FOOTER //
// ./src/components/molecules/MainNav/index.js